class Browser {
    _isMobile = false;
    _isIOS = null;
    _isWeChat = null;
    _isIE = null;

    get isMobile() {
        return window._Is_Browser_Mobile;
    }
    get isIOS() {
        if (this._isIOS === null) {
            this._isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        }
        return this._isIOS;
    }
    get isWeChat() {
        if (this._isWeChat === null) {
            this._isWeChat = (/micromessenger/.test(navigator.userAgent.toLowerCase()));
        }
        return this._isWeChat;
    }
    get isIE() {
        if (this._isIE === null) {
            this._isIE = (/trident/.test(navigator.userAgent.toLowerCase()) || /msie/.test(navigator.userAgent.toLowerCase()));
        }
        return this._isIE;
    }
}

export let browser = new Browser();